import { createStore } from 'vuex';
import helper from './modules/helper';
import layout from './modules/layout';
import page from './modules/page';
import notice from './modules/notice';
import user from './modules/user';
import modal from './modules/modal';
import dispatch from './modules/dispatch';

export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    helper,
    layout,
    page,
    notice,
    user,
    modal,
    dispatch,
  },
});
